import HamburgerMenu from './HamburgerMenu';

export default HamburgerMenu;
